import Env from '../base/env';
import { module as BaseModule } from 'modujs';
import gsap from 'gsap';

export default class extends BaseModule  {
  constructor(m) {
    super(m);
  }

  init() {
    this.el.addEventListener('suspend', () => {
      // suspend invoked
      // show play button
      // iphone is in low power mode
      // alert('low power')
    });

    this.el.addEventListener('canplay', () => {
      // suspend invoked
      // show play button
      // iphone is in low power mode

      gsap.fromTo(
        this.el,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:'cubic.inOut',
          duration:2,
          onStart:()=> this.el.style.zIndex = '2'
        }
      )
    })
  }




}
